// extracted by mini-css-extract-plugin
module.exports = {"TourPage":"TourPage_TourPage__1QV5D","storesTour":"TourPage_storesTour__2GT6J","modalMessage":"TourPage_modalMessage__p0okJ"};